import { dispatchCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["fileField"]

  connect() {
    this.hasFileFieldTarget && this.fileFieldTarget.addEventListener("change", this.afterFileSelect.bind(this))
  }

  addExisting(event) {
    event.preventDefault()
    App.Modal.closeAll();
    dispatchCustomEvent("assets--open-add-existing-form", this.element, {
      assetType: this.assetType,
      headerColor: this.slideOutHeaderColor,
      title: this.slideOutTitle
    })
  }

  uploadFiles(event) {
    this.fileFieldTarget.click()
  }

  afterFileSelect(event) {
    Array.from(this.fileFieldTarget.files).forEach((file => {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      dispatchCustomEvent("assets--file-select", this.element, { dataTransfer })
    }).bind(this))
    App.SlideOut.closeAll();
  }

  createLink(event) {
    event.preventDefault();
    dispatchCustomEvent("assets--create-new-link", this.element, {})
    App.SlideOut.closeAll();
  }

  get assetType() {
    return this.data.get("type")
  }

  get slideOutHeaderColor() {
    return this.data.get("slide-out-header-color")
  }

  get slideOutTitle() {
    return this.data.get("slide-out-title")
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-new-or-existing-options-controller.js